import { Component, OnInit } from '@angular/core';
import { ClienteService } from 'src/app/services/cliente.service';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-asesores',
  templateUrl: './asesores.component.html',
  styleUrls: ['./asesores.component.css']
})
export class AsesoresComponent implements OnInit {
  config: SwiperOptions = {

    speed: 600,
    loop: false,

    autoplay: {
        delay: 5000,
        disableOnInteraction: true
    },
    //slidesPerView: 'auto',
    slidesPerView: 'auto',
    spaceBetween: 20,
    pagination: {
        el: '.propery-carousel-pagination',
        type: 'bullets',
        clickable: true
    },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20
    },
        320: {
            slidesPerView: 1,
            spaceBetween: 20
        },


        1200: {
            slidesPerView: 3,
            spaceBetween: 20

        }
      }
  };

  public page = 1;
  public pageSize = 12;
  
  public asesores : Array<any> =[];
  public url;
  public load_data = true;

  public sort_by = '';

  constructor(private _asesorService : ClienteService) { }

  ngOnInit(): void {
    this.obtener_asesores();
  }

  obtener_asesores(){
    this._asesorService.obtener_asesores().subscribe(
      response => {
        this.asesores = response.data;
      },error =>{
        console.log(error);
      }
    )

    this.load_data = false;
  }

}
